import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { IRaffleForm, initialValues } from '../form';
import { RaffleFormDialog } from '../raffleFormDialog/RaffleFormDialog';

import { referralRaffleService } from 'v2/api/referralRaffleService';
import { handleHttpError } from 'v2/utils';

interface CreateRaffleButtonProps {
  onSuccess: VoidFunction;
}

export const CreateRaffleButton: FC<CreateRaffleButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createRaffle', referralRaffleService.createRaffle, {
    onSuccess: () => {
      onSuccess();
      toast.success('The raffle has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: IRaffleForm, resetForm: VoidFunction) => {
    trigger({
      name: values.name,
      participantsMaxCount: values.participantsMaxCount,
      reward: {
        value: values.rewardValue || undefined,
        imageId: values.rewardImageId,
      },
    }).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Add Raffle
      </Button>

      <RaffleFormDialog
        title="Create Raffle"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
